import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { MovementDataRepository } from "../domain/MovementDataRepository";
import { MovementRetrieveData } from "../domain/MovementRetrieveData";
import { MovementSumCargoAbonoByYearMonthType } from "../domain/MovementSumCargoAbonoByYearMonthType";
import { MovementSumCargoAbonoByYearMonth } from "../domain/MovementSumCargoAbonoByYearMonth";
import { MovementSumCargoAbonoSaldoByYearMonth } from "../domain/MovementSumCargoAbonoSaldoByYearMonth";
import { MovementSumReconciliationByYearMonth } from "../domain/MovementSumReconciliationByYearMonth";
import { MovementSumReconciliation } from "../domain/MovementSumReconciliation";
import { MovementSumReconciliationByYear } from "../domain/MovementSumReconciliationByYear";

export function createApiMovementDataRepository(): MovementDataRepository {
  return new ApiMovementDataRepository();
}

export class ApiMovementDataRepository extends APIRepository implements MovementDataRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  getMovementsRetrievedByCompanyAndDate(companyUid: string, dateBegin: string, dateEnd: string): Promise<MovementRetrieveData[]> {

    const dateBeginFormatted = formatDate(dateBegin);
    const dateEndFormatted = formatDate(dateEnd);


    return this.doGet<MovementRetrieveData[]>("/api/movementsdata/loaded/company/" + companyUid.toString() + "/begin/" + dateBeginFormatted + "/end/" + dateEndFormatted);
  }

  getCargoAbonoMovementsYearMonthTypeByCompany(companyUid: string): Promise<MovementSumCargoAbonoByYearMonthType>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<MovementSumCargoAbonoByYearMonthType>("/api/movementsdata/company/" + companyUid.toString() + "/resumeCargoAbonoByYearMonthType" );
    }
  }

  getCargoAbonoMovementsYearMonthByCompany(companyUid: string): Promise<MovementSumCargoAbonoByYearMonth>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<MovementSumCargoAbonoByYearMonth>("/api/movementsdata/company/" + companyUid.toString() + "/resumeCargoAbonoByYearMonth" );
    }
  }

  getCargoAbonoSaldoMovementsYearMonthByCompany(companyUid: string): Promise<MovementSumCargoAbonoSaldoByYearMonth>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<MovementSumCargoAbonoSaldoByYearMonth>("/api/movementsdata/company/" + companyUid.toString() + "/resumeCargoAbonoSaldoByYearMonth" );
    }
  }

  listResumeReconciliationMovementsYearMonth(companyUid: string): Promise<MovementSumReconciliationByYearMonth[]>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<MovementSumReconciliationByYearMonth[]>("/api/movementsdata/company/" + companyUid.toString() + "/resumeMovementsReconciliationByYearMonth" );
    }
  }

  listResumeReconciliationMovementsYear(companyUid: string): Promise<MovementSumReconciliationByYear[]>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<MovementSumReconciliationByYear[]>("/api/movementsdata/company/" + companyUid.toString() + "/resumeMovementsReconciliationByYear" );
    }
  }


  listResumeReconciliationMovements(companyUid: string): Promise<MovementSumReconciliation>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<MovementSumReconciliation>("/api/movementsdata/company/" + companyUid.toString() + "/resumeMovementsReconciliation" );
    }
  }



}

function formatDate(dateString: string): string {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Meses van de 0 a 11
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}${month}${day}`;
}
